(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartBlockedController', ChartBlockedController);

    ChartBlockedController.$inject = ['GenericEntityDatatableService', 'ChartBlocked', '$q',
        '$uibModal', 'CoreService', 'ConfirmationService'];

    function ChartBlockedController(GenericEntityDatatableService, ChartBlocked, $q,
                                    $uibModal, CoreService, ConfirmationService) {

        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id
        }

        vm.descriptor = {
            title: 'Charts Blocked',
            newButtonTitle: 'New Chart Blocked',
            entityClassHumanized: 'Charts Blocked',
            entityStateName: 'chart-blocked',
            service: ChartBlocked,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'fullName',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New ChartBlocked',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/chart-blocked/update/chart-blocked-dialog.html',
                controller: 'ChartBlockedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }],
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }]
                }
            }).result
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/chart-blocked/update/chart-blocked-dialog.html',
                controller: 'ChartBlockedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    entity: ['ChartBlocked', function (ChartBlocked) {
                        return ChartBlocked.get({id: id}).$promise;
                    }],
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('ChartBlocked').result.then(function () {
                    ChartBlocked.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
